module.exports = __webpack_public_path__ + "img/parlez-nous-800x630.4f5c6dfc.jpg";